var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5C6.34688 5 5 6.34688 5 8C5 9.65312 6.34688 11 8 11C9.65313 11 11 9.65312 11 8C11 6.34688 9.65313 5 8 5ZM15.7 7.51562L12.7406 6.0375L13.7875 2.9C13.9281 2.475 13.525 2.07188 13.1031 2.21563L9.96563 3.2625L8.48438 0.3C8.28438 -0.1 7.71563 -0.1 7.51563 0.3L6.0375 3.25938L2.89688 2.2125C2.47188 2.07188 2.06875 2.475 2.2125 2.89687L3.25938 6.03438L0.3 7.51562C-0.1 7.71562 -0.1 8.28438 0.3 8.48438L3.25938 9.9625L2.2125 13.1031C2.07188 13.5281 2.475 13.9313 2.89688 13.7875L6.03438 12.7406L7.5125 15.7C7.7125 16.1 8.28125 16.1 8.48125 15.7L9.95938 12.7406L13.0969 13.7875C13.5219 13.9281 13.925 13.525 13.7813 13.1031L12.7344 9.96562L15.6938 8.4875C16.1 8.28438 16.1 7.71562 15.7 7.51562ZM10.8281 10.8281C9.26875 12.3875 6.73125 12.3875 5.17188 10.8281C3.6125 9.26875 3.6125 6.73125 5.17188 5.17188C6.73125 3.6125 9.26875 3.6125 10.8281 5.17188C12.3875 6.73125 12.3875 9.26875 10.8281 10.8281Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMode);
export default __webpack_public_path__ + "static/media/light-mode.bd47118a.svg";
export { ForwardRef as ReactComponent };